import { useEffect } from "react";
import { BareSession } from "../models";
import { useRegistration } from "../context/Registration";
import { Accordion, Box, Button, Heading, Text } from "@chakra-ui/react";
import BottomAction from "../components/BottomAction";

type SelectCallback = (session: BareSession) => any;

type CardPropTypes = {
  session: BareSession;
  timeZone: string; // e.g. "America/Toronto"
  onSelect: SelectCallback;
  isSelected: (id: number) => boolean;
};

const SessionCard = ({
  session,
  timeZone,
  isSelected,
  onSelect,
}: CardPropTypes) => (
  <Button
    size="md"
    variant={isSelected(session.id) ? "primary" : undefined}
    key={session.id}
    onClick={() => onSelect(session)}
    mr={2}
    mb={2}
  >
    {session.startsAt.toLocaleString("en-US", {
      timeZone,
      weekday: "short",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
    })}
  </Button>
);

type PropTypes = {
  onContinue: () => void;
  onBack: () => void;
  onMount?: () => void;
};

const SelectSession = ({ onContinue, onMount }: PropTypes) => {
  const { offering, session: currentSession, setSession } = useRegistration();

  useEffect(() => {
    onMount && onMount();
  }, [onMount]);

  if (!offering) {
    //onBack();
    return null;
  }

  const selectSession = (session: BareSession) => {
    if (session.id === currentSession?.id) {
      //setSession(undefined);
    } else {
      setSession({
        ...session,
        offering,
      });
    }
  };

  return (
    <>
      <Heading size="md" mb={2}>
        Select a start date
      </Heading>
      <Accordion allowToggle>
        {offering.sessions.map((s) => (
          <SessionCard
            key={s.id}
            isSelected={(sessionId) => currentSession?.id === sessionId}
            session={s}
            onSelect={selectSession}
            timeZone={offering.timezone}
          />
        ))}
      </Accordion>

      <Box mt={{ base: 24, md: 0 }} />
      <BottomAction>
        {!currentSession && (
          <Text m={2} textAlign="center" w="100%">
            Select a session to continue.
          </Text>
        )}
        {!!currentSession && (
          <Button variant="primary" onClick={onContinue} w="100%">
            Continue
          </Button>
        )}
      </BottomAction>
    </>
  );
};

export default SelectSession;
